import type { LevelConfig } from '../index';

export const level1: LevelConfig = {
  id: 'level_1',
  stage: '1',
  mapId: 'map_01',
  timeLimitSec: null,
  playerSpawn: { x: 160, y: 160 },
  objective: { type: 'collect_coins', target: 15 },
  enemies: [
    {
      type: 'BASIC_SCAMMER',
      position: { x: 750, y: 400 },
      patrolPath: [
        { x: 750, y: 400 },
        { x: 750, y: 540 },
        { x: 830, y: 540 },
        { x: 830, y: 400 },
      ],
    },
  ],
  loot: [
    { type: 'COIN', position: { x: 320, y: 160 }, value: 10 },
    { type: 'COIN', position: { x: 480, y: 160 }, value: 10 },
    { type: 'COIN', position: { x: 640, y: 160 }, value: 10 },
    { type: 'COIN', position: { x: 160, y: 320 }, value: 10 },
    { type: 'COIN', position: { x: 320, y: 320 }, value: 10 },
    { type: 'COIN', position: { x: 480, y: 320 }, value: 10 },
    { type: 'COIN', position: { x: 160, y: 480 }, value: 10 },
    { type: 'COIN', position: { x: 320, y: 480 }, value: 10 },
    { type: 'COIN', position: { x: 160, y: 640 }, value: 10 },
    { type: 'COIN', position: { x: 320, y: 640 }, value: 10 },
    { type: 'COIN', position: { x: 480, y: 640 }, value: 10 },
    { type: 'COIN', position: { x: 160, y: 800 }, value: 10 },
    { type: 'COIN', position: { x: 320, y: 800 }, value: 10 },
    { type: 'COIN', position: { x: 480, y: 800 }, value: 10 },
    { type: 'COIN', position: { x: 640, y: 800 }, value: 10 },
    { type: 'COIN', position: { x: 800, y: 160 }, value: 10 },
    { type: 'COIN', position: { x: 800, y: 320 }, value: 10 },
    { type: 'COIN', position: { x: 800, y: 480 }, value: 10 },
    { type: 'COIN', position: { x: 800, y: 640 }, value: 10 },
    { type: 'COIN', position: { x: 800, y: 800 }, value: 10 },
  ],
  startingWeapon: null,
  startingAmmo: 0,
  unlocks: [],
};
